// useCompanyCategoryMatch — 상품 관리 오른쪽 "회사에 붙이기" 상태·API.
//   회사 목록과 각 회사의 현재 매칭을 한 번에 받는다(GET /admin/product-company-match).
//   저장 자리는 기존과 같은 app_settings 라 DB 구조 변경이 없다.
import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';

const BASE = '/api/admin/product-company-match';

export function useCompanyCategoryMatch() {
  const { showToast } = useToast();
  const [rows, setRows] = useState([]);       // 서버가 준 원래 값
  const [drafts, setDrafts] = useState({});   // { [code]: { value, is_category } } — 손댄 것만
  const [loading, setLoading] = useState(false);
  const [savingCode, setSavingCode] = useState(null);
  const [allowed, setAllowed] = useState(true); // 403 이면 칸 자체를 숨긴다(fail-closed)

  const load = useCallback(async () => {
    setLoading(true);
    const r = await apiClient.get(BASE);
    setLoading(false);
    if (!r.ok) { setAllowed(false); setRows([]); return; }
    setAllowed(true);
    setRows(Array.isArray(r.data?.data) ? r.data.data : []);
    setDrafts({});
  }, []);
  useEffect(() => { load(); }, [load]);

  function setField(code, field, value) {
    setDrafts((prev) => {
      const row = rows.find((c) => c.code === code) || {};
      const cur = prev[code] || { value: row.value || '', is_category: Boolean(row.is_category) };
      return { ...prev, [code]: { ...cur, [field]: value } };
    });
  }

  // 화면에 보여줄 값 = 손댄 게 있으면 그것, 없으면 서버 값
  function viewOf(row) {
    const d = drafts[row.code];
    return {
      value: d ? d.value : (row.value || ''),
      is_category: d ? Boolean(d.is_category) : Boolean(row.is_category),
      dirty: Boolean(d),
    };
  }

  async function save(code) {
    const row = rows.find((c) => c.code === code);
    if (!row) return;
    const v = viewOf(row);
    setSavingCode(code);
    // 빈 값은 "해제" — 예전엔 빈 값을 저장하려다 400 이 나서 해제 자체가 불가능했다.
    const r = v.value.trim()
      ? await apiClient.put(`${BASE}/${code}`, { name: v.value.trim(), is_category: v.is_category })
      : await apiClient.delete(`${BASE}/${code}`);
    setSavingCode(null);
    if (!r.ok) { showToast(r.data?.message || '저장 실패', 'error'); return; }
    showToast(v.value.trim() ? '회사 설정을 저장했습니다.' : '회사 설정을 해제했습니다.', 'success');
    await load();
  }

  return { rows, loading, savingCode, allowed, load, setField, viewOf, save };
}
